export default "__VITE_ASSET__BJRvRIwt__"